import { ReactNode } from 'react'

import { BoxSizeStep } from 'routes/Signup/Steps/BoxSize'
import { DeliveryStep } from 'routes/Signup/Steps/Delivery'
import { ExplainTheWizardStep } from 'routes/Signup/Steps/ExplainTheWizard'
import { PersonaliseMenuStep } from 'routes/Signup/Steps/PersonaliseMenu'
import { PostcodeStep } from 'routes/Signup/Steps/Postcode'
import { SignupSteps } from 'routes/Signup/constants/SignupSteps'

/**
 * SignupSteps to StepComponent relation.
 */
export const AVAILABLE_STEP_COMPONENTS: {
  [step in SignupSteps]: ReactNode
} = {
  [SignupSteps.EXPLAIN_THE_WIZARD]: ExplainTheWizardStep,
  [SignupSteps.BOX_SIZE]: BoxSizeStep,
  [SignupSteps.POSTCODE]: PostcodeStep,
  [SignupSteps.DELIVERY]: DeliveryStep,
  [SignupSteps.PERSONALISE_MENU]: PersonaliseMenuStep,
}
